var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTinyCarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 14,
    viewBox: "0 0 28 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.2924 9.17188C4.008 9.17188 2.9668 10.2131 2.9668 11.4975C2.9668 12.7819 4.008 13.8231 5.2924 13.8231C6.57619 13.8217 7.61658 12.7813 7.61801 11.4975C7.61801 10.2131 6.57681 9.17188 5.2924 9.17188Z",
    fill: "#292D32",
    fillOpacity: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0796 6.18885L24.4875 5.00567C24.3991 4.96646 24.3244 4.90191 24.2726 4.82026L22.0264 1.23974C21.6081 0.571891 20.8731 0.169113 20.085 0.175865H10.9571C10.2445 0.173697 9.57149 0.503439 9.1365 1.0679L6.24786 4.85223C6.18325 4.9387 6.09176 5.00127 5.98769 5.03001L1.15993 6.35109C0.47046 6.54306 -0.00479534 7.17319 3.65066e-05 7.88886V9.65434C3.65066e-05 10.5332 0.686964 11.2642 1.56599 11.2642H1.98655C2.1105 9.63092 3.40853 8.33289 5.04182 8.20894C6.86776 8.07036 8.46035 9.43821 8.59893 11.2642H19.0528C19.1768 9.63092 20.4748 8.33295 22.1081 8.20894C23.934 8.07036 25.5266 9.43821 25.6652 11.2642H26.434C27.313 11.2642 28 10.5332 28 9.65434V7.63896C28.0049 7.01665 27.6448 6.44921 27.0796 6.18885Z",
    fill: "#292D32",
    fillOpacity: 0.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3588 9.17188C21.0744 9.17188 20.0332 10.2131 20.0332 11.4975C20.0332 12.7819 21.0744 13.8231 22.3587 13.8231C23.6425 13.8217 24.6829 12.7813 24.6844 11.4975C24.6844 10.2131 23.6432 9.17188 22.3588 9.17188Z",
    fill: "#292D32",
    fillOpacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTinyCarIcon);
export default __webpack_public_path__ + "static/media/TinyCarIcon.ef0b68d4d411a5edbcf34b829505173b.svg";
export { ForwardRef as ReactComponent };